<template>
    <SfSection v-if="vimeoUrl">
        <template
            v-if="block.title"
            v-slot:title
        >
            {{ block.title }}
        </template>

        <sf-vimeo-embed
            :title="block.title"
            :url="vimeoUrl"
            :accessible-url="accessibleVimeoUrl"
            :caption="caption"
        />
    </SfSection>
</template>

<script>
import { get } from 'lodash-es';
import contentBlockMixin from '~/mixins/content-block';
import SfSection from '~/patterns/organisms/section/section';
import SfVimeoEmbed from '~/patterns/molecules/vimeo-embed/vimeo-embed';

export default {
    components: {
        SfSection,
        SfVimeoEmbed
    },

    mixins: [
        contentBlockMixin
    ],

    computed: {
        vimeoUrl() {
            return get(this, 'block.vimeoUrl', '');
        },

        accessibleVimeoUrl() {
            return get(this, 'block.accessibleVimeoUrl', '');
        },

        caption() {
            return get(this, 'block.caption', '');
        }
    }
};
</script>
